import { ApiOptions, Study, VisitId } from '@csp/csp-common-model';
import { StudyConfig } from '@csp/csp-common-config';
import { CacheKey, MemCacheService } from '@csp/csp-common-memcache';
import { minutesToSeconds } from '@csp/csp-common-date-util';
import { BookedPatientVisit } from '../../../patient-visits/model/BookedPatientVisit';
import { BookedPatientVisitsQueryService } from './BookedPatientVisitsQueryService';

const CACHE_VISIT = 'booked-visit';
const CACHE_TTL_SECS = minutesToSeconds(10);

const generateCacheKey = (visitId: VisitId): CacheKey => CacheKey.from([CACHE_VISIT, visitId]);

const fetchByIds = async (
  visitIds: VisitId[],
  study: Study,
  studyConfig: StudyConfig,
  apiOptions?: ApiOptions,
): Promise<BookedPatientVisit[]> => {
  const bookedVisits: BookedPatientVisit[] = [];
  const visitIdsToBeFetched: VisitId[] = [];

  for (const visitId of visitIds) {
    const cachedVisit = MemCacheService.getValue<BookedPatientVisit>(generateCacheKey(visitId));
    if (cachedVisit) {
      bookedVisits.push(cachedVisit);
    } else {
      visitIdsToBeFetched.push(visitId);
    }
  }

  if (visitIdsToBeFetched.length) {
    const fetchedBookedVisits = await BookedPatientVisitsQueryService.fetchAllByIds(
      visitIdsToBeFetched,
      study,
      studyConfig,
      undefined,
      apiOptions,
    );
    for (const fetchedVisit of fetchedBookedVisits) {
      MemCacheService.setValue(generateCacheKey(fetchedVisit.visitId), CACHE_TTL_SECS, fetchedVisit);
      bookedVisits.push(fetchedVisit);
    }
  }

  return bookedVisits;
};

export const CachedBookedPatientVisitQueryService = {
  fetchByIds,
};
